var ServerNotificationService_1;
import { __decorate } from "tslib";
import { EventEmitter, Injectable, isDevMode } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { AppConfig } from "../../../app.config";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { UrlConstants } from "../../constants/url.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { HttpTransportType, HubConnectionBuilder, LogLevel, } from "@microsoft/signalr";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
let ServerNotificationService = class ServerNotificationService {
    static { ServerNotificationService_1 = this; }
    authService;
    http;
    messageReceived = new EventEmitter();
    connectionEstablished = new EventEmitter();
    notificationSubject = new BehaviorSubject(null);
    notificationObservable = this.notificationSubject.asObservable();
    _connectionIsEstablished = false;
    _hubConnection;
    _authenticationToken;
    constructor(authService, http) {
        this.authService = authService;
        this.http = http;
        // TODO: implement signal R
        // this.listenForAuthenticationTokenChanges();
    }
    static buildHubUrl() {
        return (AppConfig.settings.api.server +
            AppRoutingConstants.ROUTE_SEPERATOR +
            UrlConstants.SIGNAL_R_HUB_SUFFIX);
    }
    static getLogLevel() {
        if (isDevMode()) {
            return LogLevel.Debug;
        }
        else {
            return LogLevel.None;
        }
    }
    newNotificationObservable(notifications) {
        this.notificationSubject.next(notifications);
    }
    getNotificationObservableValue() {
        return this.notificationSubject.value;
    }
    sendMessage(message) {
        this._hubConnection.invoke(SharedConstants.SEND_SERVER_MESSAGE_ACTION, message);
    }
    async setupConnection(authToken) {
        this.createConnection(authToken);
        this.registerServerEvents();
        await this.startConnection();
    }
    createConnection(authToken) {
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(ServerNotificationService_1.buildHubUrl(), {
            accessTokenFactory() {
                return authToken;
            },
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
            logger: ServerNotificationService_1.getLogLevel(),
        })
            // .withAutomaticReconnect()
            .build();
    }
    async startConnection() {
        try {
            await this._hubConnection.start();
            this.handleConnectionEstablished();
        }
        catch (error) {
            if (isDevMode()) {
                throw new Error(SharedConstants.SERVER_HUB_CONNECTION_ERROR_MESSAGE +
                    error.toLocaleString());
            }
        }
    }
    registerServerEvents() {
        this._hubConnection.on(SharedConstants.SERVER_MESSAGE_LISTENER_EVENT, (data) => {
            this.messageReceived.emit(data);
        });
    }
    handleConnectionEstablished() {
        this._connectionIsEstablished = true;
        this.connectionEstablished.emit(true);
    }
    closeCurrentConnection() {
        if (this.isConnectionActive()) {
            return this._hubConnection.stop();
        }
    }
    isConnectionActive() {
        return !!this._hubConnection;
    }
    static ctorParameters = () => [
        { type: AuthService },
        { type: HttpClient }
    ];
};
ServerNotificationService = ServerNotificationService_1 = __decorate([
    Injectable({
        providedIn: "root",
    })
], ServerNotificationService);
export { ServerNotificationService };
